/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCorporationsCorporationIdCustomsOffices200Ok
 */
export interface GetCorporationsCorporationIdCustomsOffices200Ok {
    /**
     * Only present if alliance access is allowed
     * @type {number}
     * @memberof GetCorporationsCorporationIdCustomsOffices200Ok
     */
    allianceTaxRate?: number;
    /**
     * standing_level and any standing related tax rate only present when this is true
     * @type {boolean}
     * @memberof GetCorporationsCorporationIdCustomsOffices200Ok
     */
    allowAccessWithStandings: boolean;
    /**
     * allow_alliance_access boolean
     * @type {boolean}
     * @memberof GetCorporationsCorporationIdCustomsOffices200Ok
     */
    allowAllianceAccess: boolean;
    /**
     * bad_standing_tax_rate number
     * @type {number}
     * @memberof GetCorporationsCorporationIdCustomsOffices200Ok
     */
    badStandingTaxRate?: number;
    /**
     * corporation_tax_rate number
     * @type {number}
     * @memberof GetCorporationsCorporationIdCustomsOffices200Ok
     */
    corporationTaxRate?: number;
    /**
     * Tax rate for entities with excellent level of standing, only present if this level is allowed, same for all other standing related tax rates
     * @type {number}
     * @memberof GetCorporationsCorporationIdCustomsOffices200Ok
     */
    excellentStandingTaxRate?: number;
    /**
     * good_standing_tax_rate number
     * @type {number}
     * @memberof GetCorporationsCorporationIdCustomsOffices200Ok
     */
    goodStandingTaxRate?: number;
    /**
     * neutral_standing_tax_rate number
     * @type {number}
     * @memberof GetCorporationsCorporationIdCustomsOffices200Ok
     */
    neutralStandingTaxRate?: number;
    /**
     * unique ID of this customs office
     * @type {number}
     * @memberof GetCorporationsCorporationIdCustomsOffices200Ok
     */
    officeId: number;
    /**
     * reinforce_exit_end integer
     * @type {number}
     * @memberof GetCorporationsCorporationIdCustomsOffices200Ok
     */
    reinforceExitEnd: number;
    /**
     * Together with reinforce_exit_end, marks a 2-hour period where this customs office could exit reinforcement mode during the day after initial attack
     * @type {number}
     * @memberof GetCorporationsCorporationIdCustomsOffices200Ok
     */
    reinforceExitStart: number;
    /**
     * Access is allowed only for entities with this level of standing or better
     * @type {string}
     * @memberof GetCorporationsCorporationIdCustomsOffices200Ok
     */
    standingLevel?: GetCorporationsCorporationIdCustomsOffices200OkStandingLevelEnum;
    /**
     * ID of the solar system this customs office is located in
     * @type {number}
     * @memberof GetCorporationsCorporationIdCustomsOffices200Ok
     */
    systemId: number;
    /**
     * terrible_standing_tax_rate number
     * @type {number}
     * @memberof GetCorporationsCorporationIdCustomsOffices200Ok
     */
    terribleStandingTaxRate?: number;
}


/**
 * @export
 */
export const GetCorporationsCorporationIdCustomsOffices200OkStandingLevelEnum = {
    Bad: 'bad',
    Excellent: 'excellent',
    Good: 'good',
    Neutral: 'neutral',
    Terrible: 'terrible'
} as const;
export type GetCorporationsCorporationIdCustomsOffices200OkStandingLevelEnum = typeof GetCorporationsCorporationIdCustomsOffices200OkStandingLevelEnum[keyof typeof GetCorporationsCorporationIdCustomsOffices200OkStandingLevelEnum];


/**
 * Check if a given object implements the GetCorporationsCorporationIdCustomsOffices200Ok interface.
 */
export function instanceOfGetCorporationsCorporationIdCustomsOffices200Ok(value: object): value is GetCorporationsCorporationIdCustomsOffices200Ok {
    if (!('allowAccessWithStandings' in value) || value['allowAccessWithStandings'] === undefined) return false;
    if (!('allowAllianceAccess' in value) || value['allowAllianceAccess'] === undefined) return false;
    if (!('officeId' in value) || value['officeId'] === undefined) return false;
    if (!('reinforceExitEnd' in value) || value['reinforceExitEnd'] === undefined) return false;
    if (!('reinforceExitStart' in value) || value['reinforceExitStart'] === undefined) return false;
    if (!('systemId' in value) || value['systemId'] === undefined) return false;
    return true;
}

export function GetCorporationsCorporationIdCustomsOffices200OkFromJSON(json: any): GetCorporationsCorporationIdCustomsOffices200Ok {
    return GetCorporationsCorporationIdCustomsOffices200OkFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdCustomsOffices200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdCustomsOffices200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'allianceTaxRate': json['alliance_tax_rate'] == null ? undefined : json['alliance_tax_rate'],
        'allowAccessWithStandings': json['allow_access_with_standings'],
        'allowAllianceAccess': json['allow_alliance_access'],
        'badStandingTaxRate': json['bad_standing_tax_rate'] == null ? undefined : json['bad_standing_tax_rate'],
        'corporationTaxRate': json['corporation_tax_rate'] == null ? undefined : json['corporation_tax_rate'],
        'excellentStandingTaxRate': json['excellent_standing_tax_rate'] == null ? undefined : json['excellent_standing_tax_rate'],
        'goodStandingTaxRate': json['good_standing_tax_rate'] == null ? undefined : json['good_standing_tax_rate'],
        'neutralStandingTaxRate': json['neutral_standing_tax_rate'] == null ? undefined : json['neutral_standing_tax_rate'],
        'officeId': json['office_id'],
        'reinforceExitEnd': json['reinforce_exit_end'],
        'reinforceExitStart': json['reinforce_exit_start'],
        'standingLevel': json['standing_level'] == null ? undefined : json['standing_level'],
        'systemId': json['system_id'],
        'terribleStandingTaxRate': json['terrible_standing_tax_rate'] == null ? undefined : json['terrible_standing_tax_rate'],
    };
}

export function GetCorporationsCorporationIdCustomsOffices200OkToJSON(json: any): GetCorporationsCorporationIdCustomsOffices200Ok {
    return GetCorporationsCorporationIdCustomsOffices200OkToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdCustomsOffices200OkToJSONTyped(value?: GetCorporationsCorporationIdCustomsOffices200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alliance_tax_rate': value['allianceTaxRate'],
        'allow_access_with_standings': value['allowAccessWithStandings'],
        'allow_alliance_access': value['allowAllianceAccess'],
        'bad_standing_tax_rate': value['badStandingTaxRate'],
        'corporation_tax_rate': value['corporationTaxRate'],
        'excellent_standing_tax_rate': value['excellentStandingTaxRate'],
        'good_standing_tax_rate': value['goodStandingTaxRate'],
        'neutral_standing_tax_rate': value['neutralStandingTaxRate'],
        'office_id': value['officeId'],
        'reinforce_exit_end': value['reinforceExitEnd'],
        'reinforce_exit_start': value['reinforceExitStart'],
        'standing_level': value['standingLevel'],
        'system_id': value['systemId'],
        'terrible_standing_tax_rate': value['terribleStandingTaxRate'],
    };
}

